export const headNavData=[
  {
    name: '在线学习',
    jumpUrl:'/online-learning',
    children: [
    ]
  }
]

// export default headNavData
